import * as Sentry from "@sentry/nextjs";
import type { ErrorInfo } from "react";

interface ProblemRenderDiagnostics {
  componentStack: string;
  pathname: string;
  problemIds: string[];
  problemCount: number;
}

// 오류 객체에만 연결한다. 다른 페이지/시험의 마지막 상태가 섞이지 않고 GC도 방해하지 않는다.
const diagnosticsByError = new WeakMap<Error, ProblemRenderDiagnostics>();

export function rememberProblemRenderError(
  error: Error,
  info: ErrorInfo,
  pathname: string,
  problemIds: readonly string[],
) {
  diagnosticsByError.set(error, {
    componentStack: info.componentStack ?? "",
    pathname,
    problemIds: problemIds.slice(0, 200),
    problemCount: problemIds.length,
  });
}

export function capturePageError(error: Error) {
  const diagnostics = diagnosticsByError.get(error);
  if (!diagnostics) return Sentry.captureException(error);

  return Sentry.captureReactException(error, {
    componentStack: diagnostics.componentStack,
  }, {
    contexts: {
      random_problems: {
        pathname: diagnostics.pathname,
        problem_ids: diagnostics.problemIds,
        problem_count: diagnostics.problemCount,
        problem_ids_truncated: diagnostics.problemCount > diagnostics.problemIds.length,
      },
    },
  });
}
